module.exports = __webpack_public_path__ + "static/media/ButtonV2.64fb2b78.css";